<template>
  <WCSinglePageForm>
    <template v-slot:title>
      {{ $t('resetPassword') }}
    </template>

    <template v-slot:title-right>
      <label>
        {{ $t('knowYourPassword') }}
        <router-link class="font-weight-bold underline-link-from-center" tabindex="0" to="/login">
          {{ $t('signIn') }}</router-link
        >
      </label>
    </template>

    <template v-slot:subheading>
      {{ $t('recommendComplexPassword') }}
    </template>

    <template v-slot:body>
      <form @submit.prevent="$emit('submit', form)">
        <WCFormGroup>
          <label for="wc-recover__password"
            >{{ $t('createNewPassword') }}<span class="text-danger"> *</span></label
          >
          <WCNewPasswordInput
            id="wc-recover__password"
            tabindex="1"
            v-model="form.password"
            :$v="$v"
          />
        </WCFormGroup>

        <button
          type="submit"
          class="btn btn-primary btn-block submit-btn"
          :disabled="$v.form.$invalid"
        >
          {{ $t('continue') }}
        </button>
      </form>
    </template>
  </WCSinglePageForm>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { password } from '@/utils/validators/validators';
import WCFormGroup from '@/modules/forms/components/WCFormGroup/WCFormGroup.vue';
import WCNewPasswordInput from '@/modules/forms/components/WCNewPasswordInput/WCNewPasswordInput.vue';
import WCSinglePageForm from '@/modules/forms/components/WCSinglePageForm/WCSinglePageForm.vue';

export default {
  components: { WCFormGroup, WCSinglePageForm, WCNewPasswordInput },
  data() {
    return {
      form: {
        password: '',
      },
      passwordActive: false,
    };
  },
  validations: {
    form: {
      password: {
        required,
        password: password(),
      },
    },
  },
};
</script>

<style lang="scss" scoped></style>
